import { Typography, useTheme, Stack } from '@mui/material';
import { get } from 'lodash';

// Components
import { IContributeDetailCompany } from 'src/utils/typings/response/contribute';
import { formatUrlNonProtocol } from 'src/utils/helpers/stringHelpers';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import RouterLinkNoUnderline from 'src/components/common/RouterLinkNoUnderline';

const SocialMediaCompany = ({ dataContribution }: { dataContribution: IContributeDetailCompany }) => {
  const theme = useTheme();

  return (
    <Stack
      width="100%"
      padding={2}
      border={`1px dashed ${theme.palette.divider}`}
      borderRadius={theme.shape.borderRadius / 2}
      spacing={2}
    >
      {getArrayDefault(
        dataContribution?.contribution_social_media_company_profile?.map((item, index) => (
          <Stack key={`contribute-email-company-${index}`} spacing={1}>
            <Typography align="left" variant="caption2" color="text.secondary" component="p">
              Social URL {index + 1}
            </Typography>
            <RouterLinkNoUnderline to={formatUrlNonProtocol(get(item, 'website', ''))} target="_blank">
              <Typography align="left" variant="body2" color="primary.main" component="p">
                {get(item, 'social_url', '')}
              </Typography>
            </RouterLinkNoUnderline>
          </Stack>
        )),
      )}
    </Stack>
  );
};

export default SocialMediaCompany;
